<script setup lang="ts">
// Round avatar with the first letter of the name, as in the production workspace bar
// (assets/js/auth.js avatarGraphic; class names are styled by the generated legacy CSS).
import { computed } from 'vue'
import { avatarKey } from '../areas/account/avatars'

const props = defineProps<{ avatar?: string; name?: string }>()
const key = computed(() => avatarKey(props.avatar))
const initial = computed(() => (props.name || '').trim().slice(0, 1))
const SHAPES: Record<string, string> = {
  mountain: '<path d="M5 18 11 7l3 5 2-3 5 9H5Z"/><path d="m9.5 10 1.5 2 1.5-1"/>',
  compass: '<circle cx="12" cy="12" r="8"/><path d="m15.5 8.5-2.1 4.9-4.9 2.1 2.1-4.9 4.9-2.1Z"/>',
  book: '<path d="M5 5.5h4.5c1.4 0 2.5.8 2.5 2v11c0-1.2-1.1-2-2.5-2H5v-11Z"/><path d="M19 5.5h-4.5c-1.4 0-2.5.8-2.5 2v11c0-1.2 1.1-2 2.5-2H19v-11Z"/>',
  sun: '<circle cx="12" cy="12" r="3.5"/><path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6 7 7M17 17l1.4 1.4M18.4 5.6 17 7M7 17l-1.4 1.4"/>',
  default: '<circle cx="12" cy="8" r="3"/><path d="M5 20a7 7 0 0 1 14 0"/>',
}
</script>

<template>
  <span class="profile-avatar" :class="`profile-avatar-${key}`" aria-hidden="true">
    <svg viewBox="0 0 24 24" v-html="SHAPES[key]" /><i>{{ initial }}</i>
  </span>
</template>
